<template>
  <div class="order-detail-invalid d-flex flex-column scroll-container">
    <v-container fluid class="d-flex flex-column scroll-container">
      <h1>{{ $t("orders.anon.invalid.title") }}</h1>
      <p>{{ $t("orders.anon.invalid.description") }}</p>
    </v-container>
  </div>
</template>
<script>
export default {
  name: "OrderInvalid",
  data() {
    return {};
  }
};
</script>
